import { AccomodationFormData, AccommodationSearchParams } from "../types/accomodation.types";
import { api } from "@/lib/axios"; // o axios directamente si no tenés wrapper

export const createAccommodation = async (data: AccomodationFormData) => {
  return await api.post("/api/accommodations/", data);
};

export const getAccommodation = async (id: string) => {
  return await api.get(`/api/accommodations/${id}`);
};

// This endpoint should be used just from accommodation crud form
export const updateAccommodation = async (id: string, data: AccomodationFormData) => {
  console.log('data for update', data);
  return await api.put(`/api/accommodations/${id}`, data);
};

export const searchAccommodations = async (data: AccommodationSearchParams) => {
  return await api.post("/api/accommodations/search", data);
};

export const exportAccommodationsToExcel = async (data: AccommodationSearchParams) => {
  return await api.post("/api/accommodations/export-excel", data, {
    responseType: 'blob',
  });
};

export const exportAccommodationListToExcel = async () => {
  return await api.post("/api/accommodations/export-list-excel", {}, {
    responseType: 'blob',
  });
};

export const updateSamplingBlock = async (accommodationId: string, data: {
  samplingBlockReasonId: null;
  samplingBlockDate: null;
}) => {
  return await api.patch(`/api/accommodations/${accommodationId}/sampling-block`, data);
};

export const updateAccommodationSampleType = async (
  accommodationId: string,
  data: { sampleTypeId: number | null }
) => {
  return await api.patch(`/api/accommodations/${accommodationId}/sample-type`, data);
};

export const updateSamplingBlockReason = async (
  accommodationId: string,
  data: { samplingBlockReasonId: number | null }
) => {
  return await api.patch(`/api/accommodations/${accommodationId}/sampling-block-reason`, data);
};

export const updateObservatoryNotes = async (
  accommodationId: string,
  data: { observatoryNotes: string | null }
) => {
  return await api.patch(`/api/accommodations/${accommodationId}/observatory-notes`, data);
};